<template>
    <div class="not-for-screen-render">
        <div ref="coverPage" :style="{
        position: 'relative',
        height: '100%',
        width: '100%',
        backgroundColor: 'white'
        }">
            <img :src="userData?.coverPageAssetUrl || coverPage" style="position: absolute; z-index: 0; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"/>
            <div style="position: absolute; z-index: 1000; top: 408px; left: 208px;
                font-size: 24px; color: #FFFFFF;
                font-family: 'GraphikRegular', sans-serif; font-weight: 400;">
                1
            </div>
            <div v-if="!userData?.coverPageAssetUrl" style="position: absolute; z-index: 1000; top: 972px; left: 72px;
            display:flex; flex-direction: column; gap: 8px;
            font-size: 24px; color: #FFFFFF;
            font-family: 'GraphikRegular', sans-serif; font-weight:400;">
                <div style="font-weight: 600; font-size:32px; padding-bottom: 4px">
                    {{ userData?.userName || '' }}
                </div>
                <div>
                    {{ gradeType || '' }}
                </div>
                <div>
                    {{ userData?.school || '' }}
                </div>
            </div>
        </div>
        <div ref="wrapperTemplateUserPerformanceReport">
            <div class="page-wrapper" style="
                display:flex;
                flex-direction:column;
                background-color: white;
                font-family: 'GraphikRegular', sans-serif;
                width: 794px;
                height: 100%;
                break-inside: avoid;
            "> 
            
            <!-- Header-->
                <div style="margin: 16px 16px 0px; width:100%; display:flex; justify-content:space-between; align-items:center; background-color: white; padding-right:16px;">
                    <div style="color: #A3A3A3; font-size: 16px; font-weight: 400;">{{ userData?.userName | capitalizeFirst }}</div>
                    <img style="height:48px;width: 200px;" :src="userData?.headerAssetUrl || userPerformanceReportHeaderImage" alt=""/>
                </div>

            <!-- Page Content -->
                <div style="margin:16px; flex: 1; height:100%; width: 794px;  overflow:auto; font-family: 'GraphikRegular', sans-serif;">
                userPerformanceReportContent
                </div>

            <!-- Footer -->
                <div style="width: 826px; background-color: white;">
                <div style="display: flex; justify-content:space-between;">
                    <div style="padding: 8px 32px; display: grid; place-items: center;">userPerformanceReportPageNumber</div>
                    <div>
                    <img style="height: 64px; width: 200px" :src="userData?.footerAssetUrl || userPerformanceReportFooterImage"/>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- Index -->
        <div ref="psychometryReportIndex" 
            style="display:flex; flex-direction:column; gap:20px; padding:0px 10px">
        
            <!-- Title -->
            <div style="display:flex; justify-content:center; font-size:20px; font-weight:550">
                Index
            </div>

            <!-- Wrapper -->
            <div style="display:flex; flex-direction: column;
                        box-shadow: 0px 2px 10px 0px #0000001F;
                        padding:24px;
                        border-radius: 8px !important;
                        gap:20px">

                <!-- Section 1 -->
                <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap: 12px">
                <div style="display:flex;">
                    <span style="font-size:16px;">1. About the test - Overview</span>
                    <span :style="getDottedSeparator(16)"></span>
                    <span>01</span>
                </div>
                </div>

                <!-- Section 2 -->
                <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap:12px">
                <div style="display:flex;">
                    <span style="font-size:16px;">2. Understanding your Report</span>
                    <span :style="getDottedSeparator(16)"></span>
                    <span>02</span>
                </div>
                </div>

                <!-- Section 3 -->
                <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap:12px">
                <div style="display:flex;">
                    <span style="font-size:16px;">3. Dimension wise Report</span>
                    <span :style="getDottedSeparator(16)"></span>
                    <span>03</span>
                </div>

                <!-- Sub Section: Dimensions -->
                <div style="display:flex; flex-direction: column; gap:12px; padding-left:30px">
                    <div v-for="(dimension, dimensionIndex) in dimensionalPagesIndex" 
                        :key="`index-dimesion-${dimensionIndex}`" 
                        style="display:flex; flex-direction:column; gap: 12px; width:100%;">
                    
                    <!-- Dimension Entry -->
                    <div style="display:flex;">
                        <span style="font-size:14px;">{{`3.${dimensionIndex+1} ${dimension?.name}`}}</span>
                        <span :style="getDottedSeparator(14)"></span>
                        <span>{{ padWithZero(dimension.pageNumber) }}</span>
                    </div>

                    <!-- Subsections -->
                    <div style="display:flex; flex-direction:column; gap:12px; padding-left:30px;">
                        <div v-for="(subsection, i) in dimension.subsections" 
                            :key="`index-subsection-${i}`" 
                            style="display:flex; width:100%;">
                        <span style="font-size:12px;">{{`3.${dimensionIndex+1}.${i+1} ${subsection?.name}`}}</span>
                        <span :style="getDottedSeparator(12)"></span>
                        <span>{{ padWithZero(subsection.pageNumber) }}</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

                <!-- Section 4 (Last Page Entries) -->
                <div style="display:flex; flex-direction: column; margin-bottom: 16px; gap:12px">
                <div style="display:flex;">
                    <span style="font-size:16px;">4. {{recommendationPagesIndex?.name}}</span>
                    <span :style="getDottedSeparator(16)"></span>
                    <span>{{ padWithZero(recommendationPagesIndex.pageNumber) }}</span>
                </div>

                <!-- Subsections -->
                <div style="display:flex; flex-direction: column; gap:12px; padding-left:30px">
                    <div v-for="(subsection, i) in recommendationPagesIndex.subsections" 
                        :key="`index-subsection-${i}`" 
                        style="display:flex; width:100%;">
                    <span style="font-size:12px;">{{`4.${i+1} ${subsection?.name}`}}</span>
                    <span :style="getDottedSeparator(12)"></span>
                    <span>{{ padWithZero(subsection.pageNumber) }}</span>
                    </div>
                </div>
                </div>

            </div>
        </div>

        <div ref="reportOverviewTemplate" style="display:flex; flex-direction: column; gap: 24px; padding: 16px;">
            <div style="display:flex; flex-direction: column;
            box-shadow: 0px 2px 10px 0px #0000001F;
            padding:24px;
            border-radius: 8px !important;
            gap:12px">
                <div style="font-weight: 600; font-size: 20px;">
                    Overview of the {{ userData?.assessmentCategoryName || '' }} Assessment
                </div>
                <div style="color: #666666;">
                    <p>{{reportOverviewContents.intro}}</p>
                    <p>{{reportOverviewContents.about}}</p>
                    <p>{{reportOverviewContents.framework}}</p>
                    <p>{{reportOverviewContents.insight}}</p>
                </div>
            </div>
            <div v-if="userData?.brainChartAssetUrl" style="display:flex; justify-content: center; align-items: center;">
                <img :src="userData?.brainChartAssetUrl" alt="" :style="{width:'100%'}">
            </div>
        </div>
        <!-- Understand Your Report -->
        <div ref="understandYourPsychometryReport" :style="{
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        paddingTop: '36px'
        }">   
            <img v-if="userData?.understandYourReportAssetUrl" :src="userData?.understandYourReportAssetUrl"  :style="{width:'100%',height: '100%'}" />
        </div>
        <!-- Dimensional Analysis -->
        <div :ref="`dimensionalAnalysis-${index}`" v-for="(dimension, index) in dimensionsForReport" :key="`dimensionalAnalysis-${index}`">
            <div v-if="dimension.isTitleCard" style="display: flex; flex-direction:column; justify-content: center; align-items: center; gap: 24px">
                <img :src="dimension.titleImage" style="width: 400px;"/>
                <div style="width:392px; min-height: 248px; display:flex; flex-direction:column; text-align: center;
                padding:36px 20px; border-radius:8px;"
                    :style="[dimension.backgroundColor, dimension.borderGradient]">
                    <h3 style="font-size: 24px; font-weight: 600; color: #212121; margin-bottom: 24px;">{{ dimension?.name }}</h3>
                    <div style="
                    word-wrap: break-word;            
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    letter-spacing: 0.0025em;
                    text-underline-position: from-font;
                    text-decoration-skip-ink: none;
                    color: #666666;">{{ dimension?.definition }} </div>
                </div>
            </div>
            <div v-else-if="dimension.isDimensionalOverview">
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                border: 1px solid #E0E0E0; 
                padding:24px;
                border-radius: 8px !important;
                gap:12px">
                    <div style="display:flex; flex-direction: column;
                    box-shadow: 0px 2px 10px 0px #0000001F;
                    padding:16px;
                    border-radius: 8px !important;">
                        <div style="font-weight: 500; font-style: Regular; font-size: 20px; text-align: justify;">Outcome</div>
                        <div style="font-weight: 400; color: #666666;">{{ dimension.outcome }}</div>
                    </div>
                    <div style="display: flex; flex-direction: row; border: 1px solid #E0E0E0; box-shadow: 0px 2px 10px 0px #0000001F; padding: 16px; border-radius: 8px;"
                    :style="{ backgroundColor: getMappedProficiencyLevelStyle(dimension?.score)?.color }">
                        <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;">
                            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                <div style="flex-grow: 1">Score</div>
                                <div style="display: flex; flex-direction: row; gap: 24px">
                                    <div>-</div>
                                    <div>{{Number(dimension.score)?.toFixed(1) || 0}}</div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;" >
                            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                <div style="flex-grow: 1">Level</div>
                                <div style="display: flex; flex-direction: row; gap: 24px">
                                    <div>-</div>
                                    <div>{{dimension.proficiencyLevel}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display:flex; flex-direction: column;
                    box-shadow: 0px 2px 10px 0px #0000001F;
                    padding:16px;
                    border-radius: 8px !important;">
                        <div style="font-weight: 500; font-style: Regular; font-size: 20px; text-align: justify;"> {{ dimension.proficiencyLevel }} </div>
                        <div style="font-weight: 400; color: #666666;">{{ dimension.proficiencyLevelDescriptor }}</div>
                    </div>
                    <div v-if="dimension?.disclaimer" style="display:flex; flex-direction: column; justify-content: center; gap: 8px;">
                        <div style="font-weight: 500; font-style: Regular; font-size: 20px; text-align: justify;">Disclaimer</div>
                        <div style="font-weight: 400; color: #666666;" v-html="dimension?.disclaimer"></div>
                    </div>
                    <div style="display:flex; flex-direction: column;
                    box-shadow: 0px 2px 10px 0px #0000001F;
                    padding:16px;
                    border-radius: 8px !important;">
                        <div style="display: flex; font-size: 20px; justify-content: space-between; font-weight: 600; gap: 8px;"> 
                            <div style="flex-grow: 1;">Sub-Dimension </div>
                            <div v-if="gradeType === 'Grade 12'" style="width:10%; text-align: center;">Score</div>
                        </div>
                        <VueApexCharts v-if="dimension.subDimensionalChartConfig"
                        type="bar"
                        width="700"
                        :height="getBarChartHeight(dimension.subDimensionalChartConfig.categories)"
                        :options="buildHorizontalBarOptions(dimension.subDimensionalChartConfig)"
                        :series="dimension.subDimensionalChartConfig.series"
                        />
                        <div v-else style="display: flex; flex-direction: column; gap: 16px;">
                            <div v-for="(subDimension, index) in dimension?.subDimensions" :key="`strengths-${index}`" style="display: flex; width:100%; justify-content: space-between; gap: 8px;">
                                <div style="width: 100%; height:36px; display: flex; border-radius: 18px; flex-grow: 1;"
                                :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                                    <div style="display: grid; place-items: center; text-align: center; width:36px; border-radius:18px; border: 0.75px solid #144FA4; font-weight:350 !important; font-size:10px;"
                                    :style="{border: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.border}">
                                        {{  dimension?.subDimensionsInLastPages + index + 1 }}
                                    </div>
                                    <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:16px;">
                                        {{subDimension?.name}}
                                    </div>
                                </div>
                                <div style="display: flex; justify-content:center; align-items:center; width:10%; height:36px; text-align: center; border-radius: 18px;" 
                                    :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                                    {{ subDimension?.score?.toFixed(1) }}
                                </div>
                            </div>
                            <div v-if="dimension.totalSubDimensions > (dimension?.subDimensions?.length + dimension?.subDimensionsInLastPages)">*Continues on next page</div>
                            <div style="display: flex; justify-content: center; gap:24px;">
                                <div style="display: flex; gap: 12px;">
                                    <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #F0E5F3;"></div>
                                    <div>Foundational</div>
                                </div>
                                <div style="display: flex; gap: 12px;">
                                    <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #DFEBFC;"></div>
                                    <div>Emergent</div>
                                </div>
                                <div style="display: flex; gap: 12px;">
                                    <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #CDF3E2;"></div>
                                    <div>Proficient</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="dimension.isSubDimensionalPage" style="display: flex; flex-direction: column; gap: 16px;">
                <div style="
                display:flex;
                flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                border: 1px solid #E0E0E0; 
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="display: flex; font-size: 20px; justify-content: space-between; font-weight: 600;"> 
                        <div style="flex-grow: 1;">Sub-Dimension </div>
                        <div v-if="gradeType === 'Grade 12'" style="width:10%; text-align: center;">Score</div>
                    </div>
                    <div v-for="(subDimension, index) in dimension?.subDimensions" :key="`strengths-${index}`" style="display: flex; width:100%; justify-content: space-between; gap: 8px;">
                        <div style="width: 100%; height:36px; display: flex; border-radius: 18px; flex-grow: 1;"
                        :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                            <div style="display: grid; place-items: center; text-align: center; width:36px; border-radius:18px; border: 0.75px solid #144FA4; font-weight:350 !important; font-size:10px;"
                            :style="{border: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.border}">
                                {{  dimension?.subDimensionsInLastPages + index + 1 }}
                            </div>
                            <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:16px;">
                                {{subDimension?.name}}
                            </div>
                        </div>
                        <div style="display: flex; justify-content:center; align-items:center; width:10%; height:36px; text-align: center; border-radius: 18px;" 
                            :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                            {{ subDimension?.score?.toFixed(1) }}
                        </div>
                    </div>
                    <div v-if="dimension.totalSubDimensions > (dimension?.subDimensions?.length + dimension?.subDimensionsInLastPages)">*Continues on next page </div>
                    <div style="display: flex; justify-content: center; gap:24px;">
                        <div style="display: flex; gap: 12px;">
                            <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #F0E5F3;"></div>
                            <div>Foundational</div>
                        </div>
                        <div style="display: flex; gap: 12px;">
                            <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #DFEBFC;"></div>
                            <div>Emergent</div>
                        </div>
                        <div style="display: flex; gap: 12px;">
                            <div style="width: 32px; height: 24px; border-radius: 4px; background-color: #CDF3E2;"></div>
                            <div>Proficient</div>
                        </div>
                    </div>
                    <div v-if="dimension.isSubStrandNotePage" style="display:flex; flex-direction: column; padding: 24px; border-radius: 8px !important; gap: 8px;"
                    :style="{ backgroundColor: getMappedProficiencyLevelStyle(0)?.color }">
                        <div style="font-weight: 500; font-size: 20px; text-align: justify;">Score Interpretation Note (Score of 0 in sub-dimensions)</div>
                        <div v-if="dimension.textBefore" style="font-weight: 400; color: #666666;" v-html="dimension.textBefore"></div>
                        <ul style="margin: 0; padding-left: 20px; color: #666666;">
                            <li v-for="(subDimension, i) in dimension.subDimensionBullets" :key="i" style="font-weight: 400;">{{ subDimension }}</li>
                        </ul>
                        <div v-if="dimension.textAfter" style="font-weight: 400; color: #666666;" v-html="dimension.textAfter"></div>
                    </div>
                </div>
            </div>
            <div v-else-if="dimension.isSubStrandNotePage" style="display:flex; flex-direction: column; gap: 24px;">
                <div style="display:flex; flex-direction: column; padding: 24px; border-radius: 8px !important; gap: 8px;"
                :style="{ backgroundColor: getMappedProficiencyLevelStyle(0)?.color }">
                    <div style="font-weight: 500; font-size: 20px; text-align: justify;">Score Interpretation Note (Score of 0 in sub-dimensions)</div>
                    <div v-if="dimension.textBefore" style="font-weight: 400; color: #666666;" v-html="dimension.textBefore"></div>
                    <ul style="margin: 0; padding-left: 20px; color: #666666;">
                        <li v-for="(subDimension, i) in dimension.subDimensionBullets" :key="i" style="font-weight: 400;">{{ subDimension }}</li>
                    </ul>
                    <div v-if="dimension.textAfter" style="font-weight: 400; color: #666666;" v-html="dimension.textAfter"></div>
                </div>
                <template v-if="dimension.mergedDominantSubDimension">
                    <div v-if="dimension.isFirstDominantSubDimPage" style="display: flex; flex-direction: row; font-weight: 600; gap: 24px;">
                        <img :src="top3SubDimensionsIcon"/>
                        <div>Dominant Sub-Dimensions</div>
                    </div>
                    <div v-for="(subDimension, index) in dimension.mergedDominantSubDimension" :key="`combined-highlight-${index}`"
                    style="display:flex; flex-direction: column; box-shadow: 0px 2px 10px 0px #0000001F; border: 1px solid #E0E0E0; border-radius: 8px; gap: 16px; padding: 16px;">
                        <div style="display: flex; flex-direction: row; align-items: center; gap:16px">
                            <div style="width: 64px; height: 64px; border-radius: 32px; display: flex; flex-direction: row; align-items: center; justify-content: center; box-shadow: 1px 1px 8px 0px #0000001F;">
                                <img v-if="subDimension?.assetUrl" style="width: 48px; height: 48px;" :src="subDimension.assetUrl" alt="">
                            </div>
                            <div style="font-weight: 600;">{{ subDimension?.name }}</div>
                        </div>
                        <div style="display: flex; flex-direction: row; border: 1px solid #E0E0E0; box-shadow: 0px 2px 10px 0px #0000001F; padding: 16px; border-radius: 8px;"
                        :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                            <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;">
                                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                    <div style="flex-grow: 1">Score</div>
                                    <div style="display: flex; flex-direction: row; gap: 24px"><div>-</div><div>{{ subDimension.score?.toFixed(1) }}</div></div>
                                </div>
                            </div>
                            <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;">
                                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                    <div style="flex-grow: 1">Level</div>
                                    <div style="display: flex; flex-direction: row; gap: 24px"><div>-</div><div>{{ subDimension.level }}</div></div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: column; box-shadow: 0px 2px 10px 0px #0000001F; padding: 16px; border-radius: 8px;">
                            <div style="font-size: 20px;">{{ subDimension?.level }}</div>
                            <div style="color: #666666;" v-html="subDimension?.definition"></div>
                        </div>
                    </div>
                </template>
            </div>
            <div v-else style="display: flex; flex-direction: column; gap: 24px;">
                <div v-if="dimension.isFirstPageOfSubDimensions" style="display: flex; flex-direction: row; font-weight: 600; gap: 24px;">
                    <img :src="top3SubDimensionsIcon"/>
                    <div>Dominant Sub-Dimensions</div>
                </div>
                <div v-for="(subDimension, index) in dimension" :key="`subDimensionalAnalysis-${index}`"
                style=" display:flex;
                flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                border: 1px solid #E0E0E0;
                border-radius: 8px;
                gap: 16px;
                padding: 16px;">
                    <div style="display: flex; flex-direction: row;align-items: center; gap:16px">
                        <div style="
                        width: 64px; height: 64px;
                        border-radius: 32px;
                        display: flex; flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        box-shadow: -1px -1px 3px 0px #00000026 inset;
                        box-shadow: 1px 1px 3px 0px #00000026 inset;
                        box-shadow: 2px 2px 8px 0px #FFFFFF80 inset;
                        box-shadow: 1px 1px 8px 0px #0000001F;">
                            <img v-if="subDimension?.assetUrl" style="width: 48px; height: 48px;" :src="subDimension.assetUrl" alt="">
                        </div>
                        <div style="font-weight: 600;">{{ subDimension?.name }}</div>
                    </div>
                    <div style="display: flex; flex-direction: row; border: 1px solid #E0E0E0; box-shadow: 0px 2px 10px 0px #0000001F; padding: 16px; border-radius: 8px;"
                    :style="{ backgroundColor: getMappedProficiencyLevelStyle(subDimension?.score?.toFixed(1))?.color }">
                        <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;">
                            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                <div style="flex-grow: 1">Score</div>
                                <div style="display: flex; flex-direction: row; gap: 24px">
                                    <div>-</div>
                                    <div>{{subDimension.score?.toFixed(1)}}</div>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: row; gap: 24px; width: 50%;" >
                            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                <div style="flex-grow: 1">Level</div>
                                <div style="display: flex; flex-direction: row; gap: 24px">
                                    <div>-</div>
                                    <div>{{subDimension.level}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; flex-direction: column; box-shadow: 0px 2px 10px 0px #0000001F; padding: 16px; border-radius: 8px;">
                        <div style="font-size: 20px;"> {{ subDimension?.level }}</div>
                        <div style="color: #666666;" v-html="subDimension?.definition">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top X recommended streams -->
        <div ref="topXRecommended" style="display: flex; flex-direction: column; gap: 24px; width: 90%; padding: 0px 24px;">
            <div style="font-weight: 600;">
                {{ gradeType  === 'Grade 8'? `Top 3 Stream Recommendations For ${userData?.firstName || ''}` : `Top 5 ${gradeType === 'Grade 10' ? 'Career' : 'Branch'} Recommendations For ${userData?.firstName || ''}`}}
            </div>
            <div style="display: flex; justify-content:center; align-items:center; box-shadow: 0px 2px 8px 0px #0000001A; padding: 16px; height:360px; width: 100%; margin: 0px auto;">
                <div style="display: flex; justify-content: center; align-items: center; height: 320px; width: 60px;">
                    <div style=" transform: rotate(-90deg); transform-origin: center; background: #B27CC429; border-radius: 30px; padding: 16px 24px; white-space: nowrap; text-align: center;">
                        {{ gradeType  === 'Grade 8'? `Top 3 Stream Recommendations For ${userData?.firstName || ''}` : `Top 5 ${gradeType === 'Grade 10' ? 'Career' : 'Branch'} Recommendations For ${userData?.firstName || ''}`}}
                    </div>
                </div>
                <div style="display: flex; flex-direction: column; justify-content: space-around; height: 320px; flex-grow: 1; padding-left: 0px; margin-left:-8px; width: 80%;">
                    <div v-for="(recommendation, index) in topXRecommended" :key="`recommended-${index}`">
                        <div
                            style="display: flex; align-items:center; padding:8px; padding-left: 0px; gap:24px; width: 100%">
                            <div :style="topXChartColorMap[index % topXChartColorMap?.length].pointer"
                             style="border-top: 20px solid transparent; border-bottom: 20px solid transparent; height: 0px; width: 0px;">
                                <div :style="topXChartColorMap[index % topXChartColorMap?.length].bullet"
                                style="position: relative; top: -20px; left: 55px; width: 40px; height: 40px; border-radius: 20px; display: flex; justify-content: center; align-items: center; text-align: center;">
                                    {{ index + 1 }}
                                </div>
                            </div>
                            <div :style="topXChartColorMap[index % topXChartColorMap?.length].content"
                             style="display:flex; align-items: center; padding: 0px 16px; height: 40px; border-radius: 20px; width: 100%; box-shadow: 0px 2px 8px 0px #0000001A;">
                                {{ recommendation?.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(recommendation, index) in topXRecommended" :key="`topXRecommendation-${index}`">
            <!-- Most Recommended stream -->
            <div :ref="`topXRecommended_${index+1}_template_1`" style="display: flex; flex-direction: column; gap:24px; padding: 16px;">
                <div style="font-weight: 600;">{{ getOrdinal(index) }} Recommended {{ gradeType === 'Grade 8' ? 'Stream' : gradeType === 'Grade 10' ? 'Career' : 'Branch' }}</div>
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                        <div style="font-weight: 600;">{{recommendation?.name}}</div>
                    </div>
                    <div style="color: #666666;">
                        <img :src="recommendation?.assetUrl" style="float: left; margin: 12px; width: 120px;" alt=""/>
                        <p>{{recommendation?.description}}</p>
                    </div>
                </div>
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;"> Dimension-wise Score</div>
                    <VueApexCharts
                    type="bar"
                    width="700"
                    :height="getBarChartHeight(recommendation?.recommendationChartConfig?.categories || [])"
                    :options="buildHorizontalBarOptions(recommendation?.recommendationChartConfig)"
                    :series="recommendation?.recommendationChartConfig?.series || []"
                    />
                </div>
            </div>
            <!-- Carreer Pathways -->
            <div :ref="`topXRecommended_${index+1}_template_2`" style="display:flex; flex-direction: column; gap:16px; padding: 16px;">
                <div style="font-weight: 600;">{{ userData?.pathwayTitle || '' }}</div>
                <div v-if="gradeType === 'Grade 8'" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:16px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;">{{ recommendation?.carreerPathway?.grade9_to_grade10?.alias }}</div>
                    <div>{{ recommendation?.carreerPathway?.grade9_to_grade10?.overview }}</div>
                </div>
                <div v-if="gradeType === 'Grade 10'" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:16px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;">Education</div>
                    <div style="color: #666666;" v-html="recommendation?.carreerPathway?.education"></div>
                </div>
                <div v-if="gradeType === 'Grade 10'" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:16px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;">Internships</div>
                    <div style="color: #666666;" v-html="recommendation?.carreerPathway?.internships"></div>
                </div>
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:16px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;"> {{recommendation?.carreerPathway?.key_subjects?.alias}}</div>
                    <RadialBubbleChart :show-bubble-contents="gradeType === 'Grade 8'" :bubbles="recommendation?.carreerPathway?.key_subjects?.data"
                    :diameter="100" :key="recommendation?.carreerPathway?.key_subjects?.data?.length">
                    </RadialBubbleChart>
                </div>
                <div v-if="gradeType === 'Grade 12'" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;"> Roles may include</div>
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                        <div v-for="(focusArea, index) in recommendation?.carreerPathway.focus_areas" :key="`focusArea-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #DFEBFC;">
                            <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                                {{focusArea}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :ref="`topXRecommended_${index+1}_template_3`" style="display:flex; flex-direction: column; gap:24px; padding: 16px;">
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:24px">
                    <div style="font-weight: 600;"> {{recommendation?.carreerPathway?.focus_areas?.alias }}</div>
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                        <div v-for="(focusArea, index) in recommendation?.carreerPathway?.focus_areas?.data" :key="`focusArea-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #DFEBFC;">
                            <div style="display: grid; place-items: center; text-align: center; background-color:#DFEBFC; width:36px; border-radius:18px; border: 0.75px solid #144FA4; font-weight:350 !important; font-size:10px;">
                                {{  index + 1 }}
                            </div>
                            <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                                {{focusArea}}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="font-weight: 600;">{{ recommendation?.carreerPathway?.grade11_to_grade12?.alias }}</div>
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:24px">
                    <div style="font-weight: 600;">{{recommendation?.carreerPathway?.core_subjects?.alias}}</div>
                   <div>
                        <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 8px;">
                            <div v-for="(coreSubject, index) in recommendation?.carreerPathway?.core_subjects?.data" :key="`${coreSubject?.name}-${index}`" style="display: flex; flex-direction: column; gap: 16px;width: 25%; border-radius: 12px; padding: 20px;" :style="getPillColor(index)">
                                <img style="width: 48px; height: 48px;" :src="coreSubject?.assetUrl" alt="">
                                <div>{{coreSubject?.name}}</div>
                                <ol>
                                    <li v-for="(subContent, index) in coreSubject?.topics" :key="`${subContent}-${index}`" style=" color: #666666;"> 
                                        {{ subContent }}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="recommendation?.carreerPathway?.optional_subjects?.data?.length > 0" :ref="`topXRecommended_${index+1}_template_4`" style="display:flex; flex-direction: column; gap:24px; padding: 16px;">
                <div v-if="gradeType === 'Grade 10'" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                        <div style="font-weight: 600;"> {{ recommendation?.carreerPathway?.certifications?.alias }}</div>
                        <div v-for="(item, index) in recommendation?.carreerPathway?.certifications?.data" :key="`item-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #DFEBFC;">
                            <div style="display: grid; place-items: center;  background-color:#DFEBFC; width:36px; border-radius:18px; border: 0.75px solid #144FA4; font-weight:350 !important; font-size:10px;">
                                {{  index + 1 }}
                            </div>
                            <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                                {{item}}
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="font-weight: 600;">
                        {{ recommendation?.carreerPathway?.optional_subjects?.alias }}
                    </div>
                    <div>
                        <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 8px;">
                            <div v-for="(subject, index) in recommendation?.carreerPathway?.optional_subjects?.data" :key="`${subject}-${index}`" style="width: 40%; min-height: 24px; border-radius: 24px; padding: 8px 20px; display:flex; justify-content: center; align-items:center;" :style="getPillColor(index)">
                                <div style="text-align: center;">{{subject}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="gradeType === 'Grade 8' && recommendation?.carreerPathway?.focus_areas_bullets" style="display:flex; flex-direction: column;
                box-shadow: 0px 2px 10px 0px #0000001F;
                padding:24px;
                border-radius: 8px !important;
                gap:16px">
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                        <div style="font-weight: 600;"> {{ recommendation?.carreerPathway?.focus_areas_bullets?.alias }}</div>
                        <div v-for="(focusArea, index) in recommendation?.carreerPathway?.focus_areas_bullets?.alias" :key="`focusArea-${index}`" style="width: 100%; height:36px; display: flex;  border-radius: 15px; background-color: #DFEBFC; padding-left:16px; padding-right: 16px;">
                            <div style="display: flex; justify-content:center; align-items:center; margin:4px 36px 4px 8px; font-weight:400; font-size:12px;">
                                {{focusArea}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CampaignController from "../controllers/CampaignController";
import staticAssessmentController from "../controllers/staticAssessmentController";
import RadialBubbleChart from "./RadialBubbleChart.vue";
import VueApexCharts from "vue-apexcharts";
import capitalizeFirst from '../filters/capitalizeFirst';
import { cloneDeep, merge } from "lodash";


export default {
    name: "PsychometryReport",
    props:{
        campaignId: {
            type: String,
            required: true,
            default: ''
        },
        assessmentResultId: {
            type: String,
            required: true,
            default: ''
        },
    },
    components: {
        RadialBubbleChart,
        VueApexCharts,
    },
    data(){
        return{
            currentDate: '12-21-2333',
            coverPage: require('@/assets/coverPage_PsychometryReport.svg'),
            userPerformanceReportHeaderImage: require('@/assets/performanceReportHeader.svg'),
            userPerformanceReportFooterImage: require('@/assets/performanceReportFooter.svg'),
            top3SubDimensionsIcon: require('@/assets/top3SubDimensionsIcon.svg'),
            gradeType: '',
            userData: {},
            dimensionalAnalysis: [],
            reportOverviewContents: {},
            dimensionsForReport: [],
            dimensionalPagesIndex: [],
            recommendationPagesIndex: {},
            topXRecommended: [],
            proficiencyLevelColorMap: [
                {proficiencyLevel: 'Proficient', color:'#CDF3E2', border: '0.75px solid #088C52'},
                {proficiencyLevel: 'Emergent', color:'#DFEBFC', border: '0.75px solid #144FA4'},
                {proficiencyLevel: 'Foundational', color:'#F0E5F3', border: '0.75px solid #88818F'},
            ],
            mergedProficiencyLevels: [],
            horizontalBarChartOptions: {
                chart: {
                    type: "bar",
                    toolbar: { show: false },
                    animations: { enabled: false },
                    background: "#ffffff"
                },
                plotOptions: {
                    bar: {
                    horizontal: true,
                    columnWidth: "70%",
                    barHeight: "24px", 
                    borderRadius: 4,
                    distributed: true,
                    dataLabels: {
                        position: "top",
                    }
                    }
                },
                stroke: {
                    show: false,
                    width: 0,
                    colors: ["transparent"]
                },
                fill: {
                    opacity: 1
                },
                dataLabels: {
                    enabled: true,
                    textAnchor: "start",
                    style: {
                    fontFamily: "GraphikRegular, sans-serif",
                    fontWeight: 400,
                    fontSize: "12px",
                    colors: ["#00000099"]
                    },
                    offsetX: 8,
                    formatter: (val) => val.toFixed(1)
                },
                xaxis: {
                    min: 0,
                    max: 11,
                    tickAmount: 11,
                    labels: {
                        formatter: (val) => (val > 10 ? "" : Math.round(val)),
                        style: {
                            fontSize: "12px",
                            colors: "#00000099"
                        }
                    },
                    axisBorder: { 
                        show: true,
                        color: "#e0e0e0" 
                    },
                    axisTicks: {
                        show: false,
                        color: "#e0e0e0" 
                    },
                    title: {
                    text: "Score",
                        style: {
                            fontSize: "16px",
                            fontWeight: 500,
                            color: "#00000099"
                        }
                    }
                },
                yaxis: {
                    labels: {
                        show: true,
                        trim:false,
                        minWidth: 200,
                        maxWidth: 280,
                        offsetY: 8,
                        formatter: (val) => this.wrapLabel(val, 36),
                        style: {
                        fontSize: "12px",
                        colors: "#00000099",
                        whiteSpace: "normal",
                        },
                    },
                    axisBorder: {
                        show: true,
                        color: "#0000005C"
                    },
                    axisTicks: {
                        show: false,
                        color: "#0000005C"
                    },
                    crosshairs: {
                        show: false
                    },
                },
                grid: {
                    borderColor: "#f1f1f1",
                    xaxis: { lines: { show: false } },
                    yaxis: { lines: { show: false } },
                    row: {
                    colors: undefined,
                    opacity: 0
                    },
                    padding: {
                    left: 10,
                    right: 60
                    }
                },
                legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    fontSize: "16px",
                    markers: {
                        width: 12,
                        height: 12, 
                        radius: 6,
                        fillColors:["#F0E5F3", "#DFEBFC", "#CDF3E2"]
                    },
                    customLegendItems: ["Foundational", "Emergent", "Proficient"],
                    labels: {
                    colors: "#212121"
                    },
                    itemMargin: {
                        horizontal: 8,
                        vertical: 4
                    },
                    onItemClick: { toggleDataSeries: false }
                },
                tooltip: {
                    enabled: false
                },
                states: {
                    normal: { filter: { type: "none" } },
                    hover: { filter: { type: "none" } },
                    active: { filter: { type: "none" } }
                },
            },
            dimensionTitleCardMap: [
                {
                    backgroundColor: {
                        backgroundColor: "#DCF6EB",
                    },
                    borderGradient: {
                        border: "4px solid #007C2A",
                        borderRadius: "8px",
                        borderImage: "linear-gradient(261.89deg, #007C2A 0%, #029745 37.2%, #04AA58 62.29%, #05B866 81.08%, #06C270 94.9%)",
                        borderImageSlice: 1,
                    },
                },
                {
                    backgroundColor: {
                        backgroundColor: "#DFEBFC",
                    },
                    borderGradient: {
                        border: "4px solid #002298",
                        borderRadius: "8px",
                        borderImage: "linear-gradient( 261.89deg, #002298 0%, #0040B6 37.2%, #0054CA 62.29%, #075ED4 81.08%, #1B72E8 94.9%)",
                        borderImageSlice: 1,
                    },
                },
                {
                        backgroundColor: {
                            backgroundColor: "#FEEDF4",
                            },
                        borderGradient: {
                            border: "4px solid #A72C5E",
                            borderRadius: "8px",
                            borderImage: "linear-gradient( 261.89deg, #A72C5E 0%, #BB4072 37.2%, #CF5486 62.29%, #D95E90 81.08%, #F77CAE 94.9%)", 
                            borderImageSlice: 1,
                        },
                },
                {
                    backgroundColor: {
                      backgroundColor: "#F4EDF7",
                    },
                    borderGradient: {
                      border: "4px solid #622C74",
                      borderRadius: "8px",
                      borderImage: "linear-gradient( 261.89deg, #622C74 0%, #764088 37.2%, #8A549C 62.29%, #945EA6 81.08%, #B27CC4 94.9%)",
                      borderImageSlice: 1,
                    },
                },
                {
                    backgroundColor: {
                      backgroundColor: "#FFF3E5",
                    },
                    borderGradient: {
                      border: "4px solid #AF5600",
                      borderRadius: "8px",
                      borderImage: "linear-gradient(261.89deg,#AF5600 0%,#C36A0B 37.2%,#D77E1F 62.29%,#E18829 81.08%,#FFA647 94.9%)",
                      borderImageSlice: 1,
                    },
                },
            ],
            topXChartColorMap: [  
                {
                    pointer: { borderRight: "80px solid #D7F2E6" },
                    bullet: { border: "2px solid #06C270", backgroundColor: "#D7F5E9" },
                    content: { backgroundColor: "#D7F5E9" }
                },
                {
                    pointer: { borderRight: "80px solid #FAF3C5" },
                    bullet: { border: "2px solid #FADC00", backgroundColor: "#FEF9D6" },
                    content: { backgroundColor: "#FEF9D6" }
                },
                {
                    pointer: { borderRight: "80px solid #D4D6F7" },
                    bullet: { border: "2px solid #3F41D1", backgroundColor: "#E6E6F9" },
                    content: { backgroundColor: "#E6E6F9" }
                },
                {
                    pointer: { borderRight: "80px solid #FEEAF2" },
                    bullet: { border: "1px solid #F77CAE", backgroundColor: "#FEEAF2" },
                    content: { backgroundColor: "#FEEAF2" }
                },
                {
                    pointer: { borderRight: "80px solid #FEE9D6" },
                    bullet: { border: "1px solid #FB7500", backgroundColor: "#FEE9D6" },
                    content: { backgroundColor: "#FEE9D6" }
                }
            ],
            pillIllustrationColors: ['#DFEBFC', '#F6DBFF', '#FFDFE5', '#CDF3E2', '#B2C20629'],
            dimensionsOptions: {},
            proficiencyLevelsMaster: [
                {proficiencyLevel: 'Proficient', descriptor:'Fully developed and consistently applied. Adapts across varied contexts, reflects independently, and may guide others. Demonstrates insight and autonomy.', min: 7, max: 10},
                {proficiencyLevel: 'Emergent', descriptor:'Partially developed skill. Applies it with moderate success in known contexts. Requires occasional prompting or guidance. Learning is evident and evolving.', min: 4, max: 6.9},
                {proficiencyLevel: 'Foundational', descriptor:'Demonstrates basic awareness or limited application of the skill. Often needs support, but shows potential and openness to learning. Skill use is emerging in structured or familiar situations.', min: 0,  max: 3.9},
            ],
            
        }
    },
    async mounted(){
        try{
            await this.getReportData();
            await this.$nextTick();
            await this.generatePsychometryReport();
        }
        catch(error){
            console.error('PDF generator Failed', error);
            this.$emit('upload-failed')
        }    
    },
    methods: {
        async getReportData(){
            this.userData = await staticAssessmentController.getPsychometryReportData(this.assessmentResultId);
            const [ firstName, lastName ] = this.userData.userName.split(" ")
            this.userData.firstName = firstName;
            this.userData.lastName = lastName;

            this.gradeType = this.userData.grade;
            this.reportOverviewContents = this.userData.reportOverviewContents;
            this.dimensionalAnalysis = this.userData.strands;
            this.mergedProficiencyLevels = merge(this.proficiencyLevelsMaster, this.proficiencyLevelColorMap).sort((a, b) => b.min - a.min);
            const dimensionsChartConfig = {
                    series: [{data: this.dimensionalAnalysis.map(({score}) => score)}],
                    categories: this.dimensionalAnalysis.map(({name})=> name)
            }
            this.dimensionsOptions = this.buildHorizontalBarOptions(dimensionsChartConfig);
            this.dimensionsForReport = this.distributeDimensions();
            this.topXRecommended = this.getTopChoices(this.userData?.streamRecommendations, this.gradeType === 'Grade 8' ? 3 : 5)
            this.dimensionalPagesIndex = this.buildIndexEntries(this.dimensionsForReport);
        },
        distributeDimensions(){
            const distributedDimensions = this.dimensionalAnalysis.flatMap((dimension, index) => {
                const titleCard = cloneDeep(this.dimensionTitleCardMap[index % this.dimensionTitleCardMap?.length]);
                titleCard.name = dimension?.name;
                titleCard.definition = dimension.dimensionDefinition;
                titleCard.titleImage = dimension.assetUrl;
                titleCard.isTitleCard = true;

                const dimensionalOverview = {
                    name: dimension?.name,
                    outcome: dimension?.dimensionOutcome || "",
                    score: dimension?.score?.toFixed(1) || 0,
                    proficiencyLevel: dimension.proficiencyLevel  || "",
                    proficiencyLevelDescriptor: this.mergedProficiencyLevels.find(({proficiencyLevel})=> proficiencyLevel === dimension?.proficiencyLevel)?.descriptor || '',
                    isDimensionalOverview: true,
                    disclaimer: dimension?.disclaimer,
                    subDimensionalChartConfig: {
                        series: [{ data: dimension.subStrand.map(({ score }) => score)}],
                        categories: dimension.subStrand.map(({ name }) => name)
                    }
                };

                const SCORE_INTERPRETATION_EXCLUSION_LIST =  [ "UNATTEMPTED" ];
                const SUBDIMENSION_RANK_THRESHOLD = 3;

                const rankedSubDimensions = this.rankByScore(dimension.subStrand, SCORE_INTERPRETATION_EXCLUSION_LIST);

                if (this.gradeType === 'Grade 12') {
                    const MAX_SUBDIMENSIONS_PER_PAGE = 20;
                    const BULLETS_PER_SUBDIMENSION_SLOT = 1.5;
                    const NOTES_BULLETS_PER_PAGE = 40;

                    const dominantSubDimensions = this.distributeHighlights(rankedSubDimensions, SUBDIMENSION_RANK_THRESHOLD);
                    if (dominantSubDimensions.length > 0) {
                        dominantSubDimensions[0].isFirstPageOfSubDimensions = true;
                        dominantSubDimensions[0].dimensionName = dimension.name;
                    }

                    const sortedSubStrand = [...dimension.subStrand].sort((a, b) => b.score - a.score);
                    const distributedSubDimensions = this.distributeSubDimensions({ ...dimension, subStrand: sortedSubStrand }, 6, MAX_SUBDIMENSIONS_PER_PAGE, true);
                    const lastSubDimensions = distributedSubDimensions[distributedSubDimensions.length - 1];
                    const subDimensionsOnLastPage = lastSubDimensions?.subDimensions?.length || 0;
                    const isThereRoomForScoreInterpretationNote = subDimensionsOnLastPage < MAX_SUBDIMENSIONS_PER_PAGE / 2;

                    let notePages = [];
                    let highlightPages = dominantSubDimensions;
                    if (isThereRoomForScoreInterpretationNote && dimension.scoreInterpretationNote && distributedSubDimensions.length  > 1) {
                        const remainingSlots = MAX_SUBDIMENSIONS_PER_PAGE - subDimensionsOnLastPage;
                        const notesOnFirstPage = Math.floor(remainingSlots * BULLETS_PER_SUBDIMENSION_SLOT);
                        notePages = this.distributeSubStrandNote(dimension.scoreInterpretationNote, NOTES_BULLETS_PER_PAGE, notesOnFirstPage);

                        if (notePages[0] && lastSubDimensions) {
                            // Only pull note-specific fields, don't overwrite subdimension page structure
                            const { isSubStrandNotePage, textBefore, textAfter, subDimensionBullets } = notePages[0];
                            Object.assign(lastSubDimensions, {
                                isSubStrandNotePage,
                                ...(textBefore && { textBefore }),
                                ...(textAfter && { textAfter }),
                                ...(subDimensionBullets && { subDimensionBullets }),
                            });
                            notePages.shift();
                        }
                    }
                    else if (dimension.scoreInterpretationNote) {
                        highlightPages = this.buildNoteWithHighlightPages(dimension.scoreInterpretationNote, rankedSubDimensions, SUBDIMENSION_RANK_THRESHOLD);
                    }
                    return [titleCard, ...distributedSubDimensions, ...notePages, ...highlightPages];
                }

                const noteHighlightPages = dimension.scoreInterpretationNote
                    ? this.buildNoteWithHighlightPages(dimension.scoreInterpretationNote, rankedSubDimensions, SUBDIMENSION_RANK_THRESHOLD)
                    : this.distributeHighlights(rankedSubDimensions, SUBDIMENSION_RANK_THRESHOLD);
                if (!dimension.scoreInterpretationNote && noteHighlightPages.length > 0) {
                    noteHighlightPages[0].isFirstPageOfSubDimensions = true;
                }
                return [titleCard, dimensionalOverview, ...noteHighlightPages];
            });

            return distributedDimensions;
        },
        distributeSubDimensions({ subStrand = [], subDimensionsInLastPages = 0, ...rest }, maxOnCurrentPage = 20 ,  maxPerPage = 20, isFirstInvocation = false) {
            const pages = [];
            const currentPageSubDimensions = subStrand?.slice(0, maxOnCurrentPage);
            const remainingSubDimensions = subStrand?.slice(maxOnCurrentPage);
            const subDimensionalOverview = {
                name: rest?.name,
                outcome: rest.dimensionOutcome || "",
                score: rest.score || "",
                proficiencyLevel: rest.proficiencyLevel || "",
                proficiencyLevelDescriptor: this.mergedProficiencyLevels.find(({proficiencyLevel})=> proficiencyLevel === rest?.proficiencyLevel)?.descriptor || '',
                isDimensionalOverview: true,
                isSubDimensionalPage: false,
            }

            const currentPage = {
                totalSubDimensions: subStrand?.length,
                subDimensions: currentPageSubDimensions,
                subDimensionsInLastPages,
                isSubDimensionalPage: true,
                ...rest,
                ...(isFirstInvocation ? subDimensionalOverview : {}),
            };
            pages.push(currentPage);
            
            subDimensionsInLastPages += currentPageSubDimensions?.length || 0;

            const hasMoreItems = remainingSubDimensions.length > 0;
            if(hasMoreItems){
                const additionalPages  = this.distributeSubDimensions({ subStrand: remainingSubDimensions, subDimensionsInLastPages, ...rest}, maxPerPage);
                pages.push(...additionalPages);
            }
            
            return pages;
        },
        rankByScore(subDimensions, scoreInterpretationExclusionList = []) {
            const sortedSubDimensions = [...subDimensions].sort((a, b) => b.score - a.score);
            const rankedSubDimensions = sortedSubDimensions.map((item, _index, array) => {
                const rank = array.filter(x => x.score > item.score).length + 1;
                return { ...item, rank };
            });
            return rankedSubDimensions.filter(({scoreInterpretation}) => !scoreInterpretationExclusionList.includes(scoreInterpretation))
        },
        distributeSubStrandNote({ noteTemplate, subDimensions }, maxBulletsPerPage = 40, maxBulletsFirstPage = maxBulletsPerPage) {
            const [textBefore, textAfter] = noteTemplate.split('{{subDimensions}}');
            const pages = [];
            let i = 0;

            while (i < subDimensions.length) {
                const isFirst = i === 0;
                const pageLimit = isFirst ? maxBulletsFirstPage : maxBulletsPerPage;
                const chunk = subDimensions.slice(i, i + pageLimit);
                i += pageLimit;
                const isLast = i >= subDimensions.length;

                pages.push({
                    isSubStrandNotePage: true,
                    subDimensionBullets: chunk,
                    ...(isFirst && { textBefore }),
                    ...(isLast && { textAfter }),
                });
            }

            return pages;
        },
        buildNoteWithHighlightPages({ noteTemplate, subDimensions }, rankedSubDimensions, rankThreshold) {
            const PAGE_HEIGHT        = 963;
            const CARD_GAP           = 24;
            const HEADER_HEIGHT      = 56;
            const CHARS_PER_LINE     = 100;
            const PX_PER_LINE        = 24;
            const NOTE_BOX_OVERHEAD  = 86;  // 24+24 padding + 30 title + 8 gap
            const MAX_BULLETS_PER_PAGE = 40;

            const [textBefore, textAfter] = noteTemplate.split('{{subDimensions}}');
            let remainingCards = rankedSubDimensions.filter(({ rank }) => rank <= rankThreshold);
            let headerShown = false;

            const notePages = [];
            let i = 0;
            while (i < subDimensions.length) {
                const isFirst = i === 0;
                const chunk   = subDimensions.slice(i, i + MAX_BULLETS_PER_PAGE);
                i += MAX_BULLETS_PER_PAGE;
                const isLast  = i >= subDimensions.length;

                const textBeforeLines = isFirst ? Math.ceil((textBefore?.replace(/<[^>]+>/g, '').length || 0) / CHARS_PER_LINE) : 0;
                const textAfterLines  = isLast  ? Math.ceil((textAfter?.replace(/<[^>]+>/g, '').length  || 0) / CHARS_PER_LINE) : 0;
                const notePageHeight  = NOTE_BOX_OVERHEAD + (textBeforeLines + chunk.length + textAfterLines) * PX_PER_LINE;

                let available = PAGE_HEIGHT - notePageHeight - (!headerShown ? HEADER_HEIGHT : 0);
                const cardsOnPage = [];
                for (const card of remainingCards) {
                    const cardHeight = this.estimateCardHeight(card) + (cardsOnPage.length > 0 ? CARD_GAP : 0);
                    if (available < cardHeight) break;
                    cardsOnPage.push(card);
                    available -= cardHeight;
                }
                remainingCards = remainingCards.slice(cardsOnPage.length);

                notePages.push({
                    isSubStrandNotePage: true,
                    subDimensionBullets: chunk,
                    ...(isFirst && { textBefore }),
                    ...(isLast  && { textAfter }),
                    ...(cardsOnPage.length > 0 && {
                        mergedDominantSubDimension: cardsOnPage,
                        isFirstDominantSubDimPage: !headerShown,
                    }),
                });
                if (cardsOnPage.length > 0) headerShown = true;
            }

            // pack any remaining cards onto standalone pages
            while (remainingCards.length > 0) {
                const cardsOnPage = [];
                let pageHeight = !headerShown ? HEADER_HEIGHT : 0;
                for (const card of remainingCards) {
                    const cardHeight = this.estimateCardHeight(card) + (cardsOnPage.length > 0 ? CARD_GAP : 0);
                    if (cardsOnPage.length > 0 && pageHeight + cardHeight > PAGE_HEIGHT) break;
                    cardsOnPage.push(card);
                    pageHeight += cardHeight;
                }
                remainingCards = remainingCards.slice(cardsOnPage.length);
                const page = [...cardsOnPage];
                if (!headerShown) { page.isFirstPageOfSubDimensions = true; headerShown = true; }
                notePages.push(page);
            }

            return notePages;
        },
        distributeHighlights(rankedItems, rankCutoff) {
            const PAGE_HEIGHT      = 963;  // A4 @96dpi(1123) - header(64) - footer(64) - content margin(32)
            const CARD_GAP         = 24;   // parent v-else gap: 24px
            const HEADER_HEIGHT    = 56;   // "Dominant Sub-Dimensions" row (~32px) + gap to first card (24px)

            const topItems = rankedItems.filter(({ rank }) => rank <= rankCutoff);
            const pages = [];
            let currentPage = [];
            let currentHeight = HEADER_HEIGHT;

            for (const item of topItems) {
                const cardHeight = this.estimateCardHeight(item) + (currentPage.length > 0 ? CARD_GAP : 0);
                if (currentPage.length > 0 && currentHeight + cardHeight > PAGE_HEIGHT) {
                    pages.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;  // subsequent pages have no header
                }
                currentPage.push(item);
                currentHeight += cardHeight;
            }
            if (currentPage.length > 0) pages.push(currentPage);
            return pages;
        },
        estimateCardHeight(subDimension) {
            // Constants calibrated against Puppeteer-rendered heights (measured 2026-06-08):
            // the earlier model over-estimated card height by ~13%, splitting cards that
            // actually fit together (e.g. the two shorter Emotional-Intelligence highlights).
            const CARD_FIXED_HEIGHT  = 210;  // border + paddings + gaps + icon row + score/level box + def-box header
            const CHARS_PER_LINE     = 100;
            const PX_PER_TEXT_LINE   = 22;   // 16px font, ~1.4 line-height
            const PX_PER_LIST_ITEM   = 22;   // each <li> ≈ one line
            const PX_PER_BLOCK_MARGIN = 14;  // collapsed margin between block elements (<p>, <ul>)

            const definition     = subDimension.definition || '';
            const textOutsideLis = definition.replace(/<li[^>]*>[\s\S]*?<\/li>/gi, '');
            const plainText      = textOutsideLis.replace(/<[^>]+>/g, '');
            const listItems      = (definition.match(/<li/gi) || []).length;
            const paragraphs     = (definition.match(/<p[^>]*>/gi) || []).length;
            const lists          = (definition.match(/<ul[^>]*>/gi) || []).length;
            const textLines      = Math.ceil(plainText.length / CHARS_PER_LINE);

            // collapsed margins: gap between each pair of block elements + first top + last bottom
            const blockElements  = paragraphs + lists;
            const marginOverhead = blockElements > 0 ? (blockElements + 1) * PX_PER_BLOCK_MARGIN : 0;

            return CARD_FIXED_HEIGHT
                + (textLines * PX_PER_TEXT_LINE)
                + (listItems * PX_PER_LIST_ITEM)
                + marginOverhead;
        },
        async generatePsychometryReport(){
            const initialPages = [
                this.$refs.psychometryReportIndex,
                this.$refs.reportOverviewTemplate,
                this.$refs.understandYourPsychometryReport,
            ];
            const dimensionalAnalysisTemplates = this.dimensionsForReport.map((_, index)=> this.$refs[`dimensionalAnalysis-${index}`][0]);
            const topXRecommendedTemplates = this.topXRecommended.flatMap(( _, index)=>{
                return [
                    this.$refs[`topXRecommended_${index+1}_template_1`][0],
                    this.$refs[`topXRecommended_${index+1}_template_2`][0],
                    ...(this.gradeType === "Grade 8" ? [this.$refs[`topXRecommended_${index+1}_template_3`][0]] : []),
                    ...(this.$refs[`topXRecommended_${index+1}_template_4`]?.[0] ? [this.$refs[`topXRecommended_${index+1}_template_4`][0]] : []),
                ]
            });
            const latterPages = [
                this.$refs.topXRecommended,
                ...topXRecommendedTemplates
            ];

            const allPages = [ ...initialPages, ...dimensionalAnalysisTemplates, ...latterPages ];
            await this.generateReport(allPages, 'advanceReport');
            
            this.$emit('upload-completed');
        },
        async generateReport(allPages, reportType, isFocusedReport = false){
            // generate filename
            const fileName = `${this.userData?.userName}_${reportType}_${this.getCurrentDate(true)}`

            const coverPage = this.$refs.coverPage.cloneNode(true);
            // create temporary container
            const container = document.createElement('div');

            //adding cover page
            container.innerHTML += coverPage.outerHTML;

            // wrapping contents of each page with header and footer templates
            allPages.forEach((page, index) => {
            let isIndexPage = false;
            if(index == 0)isIndexPage=true;

            container.innerHTML += this.wrapPageContent(page.outerHTML, index, isIndexPage);
            });

            //upload html content of report
            await CampaignController.dispatchPsychometryReport(container.innerHTML, reportType, fileName, this.assessmentResultId, this.campaignId);

            return;
        },
        wrapPageContent(content, pageNumber, isIndexPage) {
            const wrapperTemplate = this.$refs.wrapperTemplateUserPerformanceReport.innerHTML;
            let wrappedPageContent = wrapperTemplate.replace('userPerformanceReportContent', content);
            wrappedPageContent = wrappedPageContent.replace('userPerformanceReportPageNumber', isIndexPage?"":pageNumber)
            return wrappedPageContent;
        },
        getCurrentDate(isDateForFileName = false){
            const date = new Date();
            const day = isDateForFileName? String(date.getDate()).padStart(2, '0') : date.getDate();
            const month = isDateForFileName ? String(date.getMonth() + 1).padStart(2, '0') : date.toLocaleString('en-US', { month: 'long' });
            const year = date.getFullYear();
            const currentDate = isDateForFileName? `${day}${month}${year}` : `${month} ${day}, ${year}`;
            return currentDate;
        },
        getMappedProficiencyLevelStyle(score){
            return this.mergedProficiencyLevels.find(({min, max}) => score >= min && score <= max);
        },
        buildHorizontalBarOptions({ categories = [], series = [] } = {}) {
            const data = series[0]?.data || [];
            return {
                ...this.horizontalBarChartOptions,
                xaxis: { ...this.horizontalBarChartOptions.xaxis, categories },
                colors: data.map((score) => this.getMappedProficiencyLevelStyle(score)?.color || '#F0E5F3')
            };
        },
        getBarChartHeight(categories) {
            const barHeight = 52;   // px per bar
            const minHeight = 400;
            const maxHeight = 540;
            return Math.min(
                Math.max(categories.length * barHeight, minHeight),
                maxHeight
            );
        },
        getPillColor(index){
            return {
                backgroundColor: this.pillIllustrationColors[index % this.pillIllustrationColors?.length]
            }
        },
        getDottedSeparator(dottedElementHeight){
            return {
            flex: 1,
            margin: "0 8px",
            borderBottom: "0.5px dotted #212121",
            alignSelf: "center",
            height: `${dottedElementHeight}px`
            }
        },
        buildIndexEntries(distributedDimensions) {
            const indexEntries = [];
            let pageCounter = 3; // start page numbers
            const recommendationType = 
                this.gradeType === 'Grade 8' ? 'Stream' : 
                this.gradeType === 'Grade 10' ? 'Career' : 
                'Branch';
            
            let currentDimension = null;

            for (let i = 0; i < distributedDimensions.length; i++) {
                const page = distributedDimensions[i];

                // Dimension (title card)
                if (page.isTitleCard) {
                    currentDimension = {
                        type: "dimension",
                        name: page?.name,
                        pageNumber: pageCounter,
                        subsections: []
                    };
                    indexEntries.push(currentDimension);
                }

                // Sub Dimensions page
                if (page.isDimensionalOverview && currentDimension) {
                    currentDimension.subsections.push({
                        type: "subDimensions",
                        name: `Sub Dimensions of ${page?.name}`,
                        pageNumber: pageCounter
                    });
                }

                // Top 3 Sub Dimensions — pulled up into a notes page or on its own page
                if ((page.mergedDominantSubDimension || Array.isArray(page)) && currentDimension) {
                    const alreadyHasTop3 = currentDimension.subsections.some(
                        s => s.type === "dominantSubDimensions"
                    );

                    if (!alreadyHasTop3) {
                        currentDimension.subsections.push({
                            type: "dominantSubDimensions",
                            name: `Dominant Sub-Dimensions`,
                            pageNumber: pageCounter
                        });
                    }
                }

                pageCounter++;
            }

            // Keep "lastEntries" as a separate state variable
            const recommendationPageStart = pageCounter + 1;
            let runningOffset = 0;

            this.recommendationPagesIndex = {
                type: "lastEntries",
                name: `Top ${this.gradeType === 'Grade 8' ? '3' : '5'} ${recommendationType} Recommendations`,
                pageNumber: pageCounter,
                subsections: this.topXRecommended.map((recommendation, index) => {
                    const currentPage = recommendationPageStart + runningOffset;
                    runningOffset += this.getPagesInRecommendation(recommendation, index);

                    return {
                        type: "lastEntries",
                        name: `${this.getOrdinal(index)} Recommended ${recommendationType}`,
                        pageNumber: currentPage
                    };
                })
            };

            return indexEntries;
        },
        getPagesInRecommendation(recommendation, index) {
            let count = 2; // templates 1 and 2 always exist
            if(['Grade 8'].includes(this.gradeType)) count++ ; // template 3 only renders for specific grades
            if(recommendation?.carreerPathway?.optional_subjects?.data?.length > 0) count++ // template 4 only renders when data for optional_subjects exists
            
            return count;
        },
        padWithZero(number){
            return number < 10 ? `0${number}` : `${number}`;
        },
        getTopChoices(data = [], x) {
            return [...data]
                .sort((a, b) => (b?.score ?? 0) - (a?.score ?? 0))
                .slice(0, x)
                .map((choice) => this.buildRecommendationChartConfig(choice));
        },
        buildRecommendationChartConfig(choice = {}) {
            const { dimensionWiseScoring = {} } = choice;
            const entries = Object.entries(dimensionWiseScoring);
            const recommendationScores = entries.map(([_, score]) => score ?? 0);
            const strandNames = entries.map(([strandId]) => this.getStrandNameById(strandId, this.dimensionalAnalysis));
            const recommendationChartConfig = {
                series: [{ data: recommendationScores }],
                categories: strandNames
            };
            return { ...choice, recommendationChartConfig };
        },
        getStrandNameById(id, strands = []){
            return strands.find(({strandId}) => strandId === id)?.name || '';
        },
        getOrdinal(index) {
            const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];
            return ordinals[index];
        },
        wrapLabel(text, maxChars){
            const words = String(text || "").split(" ");
            const lines = [];
            let line = "";

            for (const word of words) {
                const next = line ? `${line} ${word}` : word;
                if (next.length <= maxChars) line = next;
                else {
                    if (line) lines.push(line);
                    line = word;
                }
            }
            if (line) lines.push(line);
            return lines;
        }
    }
}
</script>
<style scoped></style>